import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "../../../libs/css/dataTable.css";
import Nulls from "../Nulls";
import Spinner from "../../../../src/Spinner/Spinner";
import { API_ROUTES } from "../../../utils/constants";
import { Link, useNavigate } from "react-router-dom";
import { getToken } from "../../../utils/getToken";
import Swal from "sweetalert2";

function CompanyReportTable(props) {
  const {
    capitalizeWords,
    isLoading,
    setIsLoading,
    columns,
    dataList,
    setDataList,
    setPage,
    isFade,
    setIsFade,
    isAuthExpired,
    objectToFormData,
    setColumns,
  } = props;

  const [loading, setLoading] = useState(true);
  const [operatorList, setOperatorList] = useState([]);

  const [pageNumber, setPageNumber] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(20);

  const navigate = useNavigate();
  const ExpandedComponent = ({ data }) => (
    <div className="text-left th_data mt-3 pb-4">
      <div>
        <font>Action: &nbsp;&nbsp; </font>
        <span style={{ textTransform: "uppercase" }}>
          {/* {data.keyword},...{" "} */}
          <Link
            to={{
              pathname: "/marketers",
            }}
            state={{ rowData: data }}
            style={{
              fontSize: "13px",
              textTransform: "none",
              backgroundColor: "#6a73fa",
              border: 'none',
              color: "#fff",
              padding: "8px 10px",
              borderRadius: '6px'
            }}
          >
            View Marketer
          </Link>
          <Link
            to={{
              pathname: "/company/update",
            }}
            state={{ rowData: data }}
            style={{
              fontSize: "13px",
              textTransform: "none",
              backgroundColor: "#6a73fa",
              border: 'none',
              color: "#fff",
              padding: "8px 10px",
              borderRadius: '6px'
            }}
            className="bg-primary_ mx-2"
          >
            Update Company
          </Link>
          <Link
            to={{
              pathname: "/company/analytics",
            }}
            state={{ rowData: data }}
            style={{
              fontSize: "13px",
              textTransform: "none",
              backgroundColor: "#6e73b3",
              border: 'none',
              color: "#fff",
              padding: "8px 10px",
              borderRadius: '6px'
            }}
            className="bg-sucess_ mx-1"
          >
            View Analytics
          </Link>
          <Link
            to={{
              pathname: "/company/delete",
            }}
            state={{ rowData: data }}
            style={{
              fontSize: "13px",
              textTransform: "none",
              backgroundColor: "red",
              border: 'none',
              color: "white",
              padding: "8px 10px",
              borderRadius: '6px'
            }}
            className="bg-danger_ mx-1"
          >
            Delete Company
          </Link>
        </span>
      </div>
    </div>
  );

  const getAllCompanyDataBylenght2 = async () => {
    const token = getToken();
    if (!token) {
      Swal.fire({
        title: "Error",
        text: "Please log in first.",
        icon: "error",
      });

      // Clear specific items from local storage
      localStorage.removeItem("companyName");
      localStorage.removeItem("userVASData");

      // Redirect to the login page
      navigate("/login");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(API_ROUTES.GET_ALL_COMPANY, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorMessages = {
          400: "Bad Request. Please check your input.",
          401: "Unauthorized. Please log in again.",
          404: "Not Found. The requested resource could not be found.",
          500: "Internal Server Error. Please try again later.",
          503: "Service Unavailable. Please try again later.",
        };

        if (response.status === 401) {
          // Show SweetAlert
          Swal.fire({
            title: "Unauthorized",
            text: "Please log in again.",
            icon: "error",
          }).then(() => {
            // Clear data from local storage
            localStorage.removeItem("userVASData");
            localStorage.removeItem("companyName");
            // Redirect the user to the login page
            navigate("/login");
          });
        } else {
          Swal.fire({
            title: "<span className='error_title'>Error</span>",
            html:
              errorMessages[response.status] || `Unexpected error occurred.`,
            icon: "error",
          });
        }

        throw new Error(errorMessages[response.status] || "Unexpected error.");
      }

      const responseJSON = await response.json();

      if (Array.isArray(responseJSON)) {
        const sortedData = responseJSON;
        // console.log("this is company data", sortedData);
        // get total row and save to state
        setTotalRows(sortedData.length);
      } else {
        console.error("Unexpected response format:", responseJSON);
      }
    } catch (error) {
      console.error("Error getting data:", error);
      setTotalRows(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllCompanyDataBylenght2();
  }, []);

  const getAllCompany = async (PageNumber) => {
    const token = getToken();
    if (!token) {
      Swal.fire({
        title: "Error",
        text: "Please log in first.",
        icon: "error",
      });

      // Clear specific items from local storage
      localStorage.removeItem("companyName");
      localStorage.removeItem("userVASData");

      // Redirect to the login page
      navigate("/login");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${API_ROUTES.GET_ALL_COMPANY}?PageSize=${pageSize}&PageNumber=${PageNumber}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      // console.log(
      //   "response getAllCompany===================getAllCompany===========-",
      //   response
      // );

      if (!response.ok) {
        const errorMessages = {
          400: "Bad Request. Please check your input.",
          401: "Unauthorized. Please log in again.",
          404: "Not Found. The requested resource could not be found.",
          500: "Internal Server Error. Please try again later.",
          503: "Service Unavailable. Please try again later.",
        };

        if (response.status === 401) {
          // Show SweetAlert
          Swal.fire({
            title: "Unauthorized",
            text: "Please log in again.",
            icon: "error",
          }).then(() => {
            // Clear data from local storage
            localStorage.removeItem("userVASData");
            localStorage.removeItem("companyName");
            // Redirect the user to the login page
            navigate("/login");
          });
        } else {
          Swal.fire({
            title: "<span className='error_title'>Error</span>",
            html:
              errorMessages[response.status] || `Unexpected error occurred.`,
            icon: "error",
          });
        }

        throw new Error(errorMessages[response.status] || "Unexpected error.");
      }

      const responseJSON = await response.json();
      // console.log("data from api call", responseJSON);
      if (Array.isArray(responseJSON)) {
        // console.log("Response data:", responseJSON);
        // setOperatorList(responseJSON.slice().reverse());
        // setDataList(responseJSON.slice().reverse());
        const sortedData = responseJSON
          .slice()
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        setOperatorList(sortedData);
        setDataList(sortedData);
        // setTotalRows(sortedData.length);
        // console.log("Total rows:", sortedData.length);
      } else {
        console.error("Unexpected response format:", responseJSON);
      }
    } catch (error) {
      console.error("Error getting data:", error);
      setOperatorList([]);
      setDataList([]);
      // setTotalRows(0);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setPageNumber(page);
    getAllCompanyDataBylenght2();
  };

  const handlePerPageChange = (pageSize) => {
    setPageSize(pageSize);
    setPageNumber(1); // Reset to page 1 when changing rows per page
  };

  useEffect(() => {
    getAllCompany(pageNumber);
  }, [pageNumber]);

  return (
    <div className="App">
      <div style={{ opacity: isFade ? "0.3" : 1 }} className="mt-0">
        {loading && <Spinner loading={loading} />}

        <DataTable
          className="services_datatable display text-nowrap"
          title=""
          expandableRows
          expandableRowsComponent={ExpandedComponent}
          columns={columns}
          data={dataList}
          highlightOnHover
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          paginationPerPage={pageSize}
          paginationComponentOptions={{
            noRowsPerPage: true,
          }}
          progressPending={loading}
          paginationDefaultPage={pageNumber}
          // onChangePage={(pageNumber) => setPageNumber(pageNumber)}
          // onChangeRowsPerPage={handlePageChange}
          onChangeRowsPerPage={handlePerPageChange}
          // onChangePage={handlePageChange}
          onChangePage={handlePageChange}
        />
      </div>
    </div>
  );
}

export default CompanyReportTable;
